import styled, { css } from 'styled-components';
import { getMediaQuery } from '@carvana/showroom-theme';
import { Section, InnerSection } from '../../../styles/section/section';
import { HeaderTextBlock } from '../../../styles/text-block/header-text-block';

export const SectionWrapper = styled(Section)`
  padding-top: 2rem;
  min-height: 20rem;
`;

export const HeaderTextBlockLeftAlign = styled(HeaderTextBlock)`
  padding-top: 1.5rem;
  text-align: center;
  align-items: center;

  ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
    align-items: start !important;
    text-align: left !important;

    > div {
      margin: 0;
      margin-bottom: 1rem;
    }
  }
`;

export const InnerSectionWrapper = styled(InnerSection)`
  padding-top: 0;
  display: flex;
  flex-direction: column;

  ${(props) => getMediaQuery(props.theme.breakpoint.lg)} {
    flex-direction: row;
  }

  ${(props) => props.hasCarousel && 'flex-direction: column !important'};
`;

const VerticalAlignment = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HeaderWrapper = styled.div`
  ${(props) => props.videoCount === 1 && VerticalAlignment};

  ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
    padding-right: 1rem;
  }
`;

export const HeroVideoWrapper = styled.div`
  width: 100%;

  ${(props) => props.hasCarousel && 'padding-top: 2rem'};

  ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
    padding-top: 2rem;
  }
`;

export const HeaderTextBlockDescription = styled(HeaderTextBlock.Description)`
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;

  ${(props) => getMediaQuery(props.theme.breakpoint.lg)} {
    max-width: 42.1875rem;
  }
`;
